module.exports = __webpack_public_path__ + "img/chevron-right-solid.1fce7054.svg";